import React from 'react';
import { useStars } from './StarContext';
import { Button, Col, Card, Row } from 'react-bootstrap';

function Season1() {
  const { sezon1 } = useStars();
console.log(sezon1);
  return (
    <Row>
      {Array.isArray(sezon1) && sezon1.map((star) => (
        <Col xs={12} sm={12} md={4} key={star.episode} className="mb-4">
          <Card className="bg-dark text-white">
            <Card.Img
              variant="top"
              src={`/image/${star.image}`}
              alt={`Seria ${star.episode}`}
            />
            <Card.Body>
              <Card.Title>Краткое описание</Card.Title>
              <Card.Text>
                {star.description}
              </Card.Text>
              <Button
                variant="primary"
                href={`/season_1/${star.episode}`}
              >
                Episode: {star.episode}
              </Button>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export { Season1 };
